let originalRender = () => {};

// 存储多个 root 实例
const rootMap = new Map();

if (globalThis.ReactDOM) {
  // const defaultContainer = document.getElementById('root');
  originalRender = (element, icontainer) => {
    // render()的容器为body是，转为defaultContainer
    const container = icontainer;
    // const container = icontainer === document.body ? defaultContainer : icontainer;
    let root = rootMap.get(container);
    if (!root) {
      // 如果不存在，则创建新的 root 并存储到 Map 中
      root = globalThis.ReactDOM.createRoot(container);
      rootMap.set(container, root);

      // 添加清理逻辑
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (!document.contains(container)) {
            // 容器被移除，执行清理
            root.unmount();
            rootMap.delete(container);
            observer.disconnect();
          }
        });
      });

      // 观察 DOM 变化
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
    root.render(element);
  };

  // 添加 unmount 方法
  // const unmount = (container) => {
  //   const root = rootMap.get(container);
  //   if (root) {
  //     root.unmount();
  //     rootMap.delete(container);
  //   }
  // };

  // externals 导出的模块可能已经持有原始 ReactDOM 对象，必须原地修改。
  globalThis.ReactDOM.render = originalRender;
} else {
  globalThis.ReactDOM = {};
}

const createRoot = globalThis.ReactDOM.createRoot || function () {};
const render = originalRender;

export {
  createRoot,
  render,
};

export default globalThis.ReactDOM;
